import { render } from "./FreeAnswer.vue?vue&type=template&id=3b405cf6&ts=true"
import script from "./FreeAnswer.vue?vue&type=script&lang=ts"
export * from "./FreeAnswer.vue?vue&type=script&lang=ts"

import "./FreeAnswer.vue?vue&type=style&index=0&id=3b405cf6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__